module.exports = __webpack_public_path__ + "img/Mauritius.ead42a4f.svg";